export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-10-01T16:02:45",
  lastPipeline: "6654",
  version: "0.0.0",
  sentryDsn: '',
};
